import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import BasicInfo from '../Common/BasicInfo';
import * as Steps from './steps';
import { getSessionStorageItem, setSessionStorageItem, SESSION_STORAGE_BASIC_INFO_KEY } from '../../../sessionStorage';
import { saveSessionEvent } from '../../../session';
import './LongTerm.scss';

export default function LongTerm(props) {
  useEffect(() => {
    saveSessionEvent();
  }, [props.location]);

  const { path } = useParams();
  const SESSION_STORAGE_KEY = 'LONGTERM_LDI';

  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill');
  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_KEY);
  const sessionStorageBasicInfo = getSessionStorageItem(SESSION_STORAGE_BASIC_INFO_KEY);
  const basicInfo = sessionStorageBasicInfo ? sessionStorageBasicInfo : BasicInfo.DefaultFormState(prefill);

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 1;
  }

  const specs = {
    age: { min: 18, max: 60 },
    coverageAmount: { min: 25000, max: 100000 },
  };

  const newFormState = {
    currentStep: 1,
    pages: {
      employmentDetails: Steps.EmploymentDetails.DefaultFormState(prefill),
      quoter : Steps.Quoter.DefaultFormState(prefill)
    },
  };

 

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // Update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    let nextStep = steps.find((s) => s.path === path);

    if (!nextStep) {
      return;
    }

    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    const nextStep = steps.find((s) => s.step === formState.currentStep + 1);

    if (!nextStep) {
      throw new Error('onNext did not find a next step');
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    props.history.push(`/quote/disability/long-term/${nextStep.path}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    const backStep = steps.find((s) => s.step === formState.currentStep - 1);
    
    if (!backStep) {
      props.history.push(`/landing/income-long-term-disability`);
      return
    }

    const newFormState = { ...formState, currentStep: backStep.step };
    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    props.history.push(`/quote/disability/long-term/${backStep.path}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const steps = [
    {
      step: 1,
      path: 'employment-details',
      progressTitle: 'Customize',
      component: (
        <Steps.EmploymentDetails
          formState={formState.pages.employmentDetails}
          basicInfo={basicInfo}
          onFieldChange={(field, value) => onFieldChange('employmentDetails', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      hideProgressTracker: true,
    },
    {
      step: 2,
      path: 'quoter',
      progressTitle: 'Customize',
      component: (
        <Steps.Quoter
          formState={formState.pages.quoter}
          basicInfo={basicInfo}
          fullFormState={formState}
          onFieldChange={(field, value) => onFieldChange('quoter', field, value)}
          onNext={() => {}}
          onBack={onBack}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      hideProgressTracker: true,
      showContainer: false,
    },
  ];

  const currentStepObj = steps.find((s) => s.step === formState.currentStep) || steps[0];

  return (
    <div>
      <Helmet>
        <title>Long Term Care - Customize </title>
      </Helmet>
      <HeaderStepper
        title="Compare and Apply"
        hidden={props.landing}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.progressTitle}
        step={formState.currentStep}
        totalSteps={steps.length}
        showContainer={true}
        hideContact={true}
        isLightHeader={true}
      >
        <div className="Long-Term">{currentStepObj.component}</div>
      </HeaderStepper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/LongTerm/LongTerm.js